import { render, staticRenderFns } from "./gkrySearchData.vue?vue&type=template&id=dc98b22a&"
import script from "./gkrySearchData.vue?vue&type=script&lang=js&"
export * from "./gkrySearchData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports